// AUTO-GENERATED by scripts/build-audio-wasm.sh — do not edit by hand.
// Cache-bust token = sha1(wasm + glue + processor); see build-audio-wasm.sh.
export const DJ_AUDIO_VERSION = 'ca37e7b92785';
